"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.becomeADealerFormRules = exports.accountsFormRules = exports.identificationFormRules = exports.incomeFormRules = exports.residenceFormRules = exports.personalFormRules = exports.sharedFormValidator = void 0;
const field_rules_1 = require("./field-rules");
Object.defineProperty(exports, "accountsFormRules", { enumerable: true, get: function () { return field_rules_1.accountsFormRules; } });
Object.defineProperty(exports, "becomeADealerFormRules", { enumerable: true, get: function () { return field_rules_1.becomeADealerFormRules; } });
Object.defineProperty(exports, "identificationFormRules", { enumerable: true, get: function () { return field_rules_1.identificationFormRules; } });
Object.defineProperty(exports, "incomeFormRules", { enumerable: true, get: function () { return field_rules_1.incomeFormRules; } });
Object.defineProperty(exports, "personalFormRules", { enumerable: true, get: function () { return field_rules_1.personalFormRules; } });
Object.defineProperty(exports, "residenceFormRules", { enumerable: true, get: function () { return field_rules_1.residenceFormRules; } });
const forms = {
    personalFormRules: field_rules_1.personalFormRules,
    residenceFormRules: field_rules_1.residenceFormRules,
    incomeFormRules: field_rules_1.incomeFormRules,
    identificationFormRules: field_rules_1.identificationFormRules,
    accountsFormRules: field_rules_1.accountsFormRules,
    becomeADealerFormRules: field_rules_1.becomeADealerFormRules,
};
const sharedFormValidator = (form, field, value, optionalArgs) => {
    const errors = [];
    const formToValidate = forms[form];
    formToValidate[field].rules.forEach((rule) => {
        const { error } = rule(value);
        if (error) {
            errors.push(error);
        }
    });
    return { field, value, errors };
};
exports.sharedFormValidator = sharedFormValidator;
